import React from 'react';

const TriangleCautionIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.99898 6.00145V8.66812M7.99898 11.3348H8.00564M14.4856 12.0015L9.15231 2.66812C9.03602 2.46292 8.86738 2.29224 8.66359 2.1735C8.45981 2.05475 8.22817 1.99219 7.99231 1.99219C7.75645 1.99219 7.52481 2.05475 7.32103 2.1735C7.11724 2.29224 6.9486 2.46292 6.83231 2.66812L1.49898 12.0015C1.38143 12.205 1.3198 12.4361 1.32032 12.6711C1.32084 12.9062 1.3835 13.137 1.50194 13.34C1.62039 13.5431 1.79041 13.7112 1.99477 13.8273C2.19914 13.9435 2.43058 14.0036 2.66564 14.0015H13.3323C13.5662 14.0012 13.796 13.9394 13.9985 13.8223C14.201 13.7052 14.3691 13.5368 14.486 13.3342C14.6028 13.1315 14.6643 12.9017 14.6643 12.6678C14.6642 12.4338 14.6026 12.204 14.4856 12.0015Z'
        stroke='#FF0500'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TriangleCautionIcon;
